import "@/plugins/bridge.js";
import { wxshareInit } from "@/plugins/wechatSDK.js";

export default function useShare(title, image, desc, url) {
  const userAgentString = navigator.userAgent.toLowerCase();
  if (userAgentString.indexOf("zsrbapp") >= 0) {
    window.ZsrbApp.call("shareInfo", {
      title: title,
      img: image,
      desc: desc,
      url: url,
    });
  } else if (userAgentString.indexOf("micromessenger") >= 0) {
    wxshareInit({
      title: title,
      imgUrl: image,
      description: desc,
      url: url,
      successMethod: "",
    });
  }
}
